import React, { useState, useEffect, useRef } from "react";
import Menubar from "../Menubar/Menubar";
import { useNavigate } from "react-router-dom";
import { Outlet } from "react-router-dom";
import "../Dashboard/Dashboard.css";
import { Tooltip } from "antd";
import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
import { MdKeyboardDoubleArrowRight } from "react-icons/md";
import { FaEye } from "react-icons/fa";
// import { MdCancel } from "react-icons/md";
// import { FiUploadCloud } from "react-icons/fi";
import { MdDelete } from "react-icons/md";
import { VscFeedback } from "react-icons/vsc";
import { VscFileSubmodule } from "react-icons/vsc";
import { IoStarHalf } from "react-icons/io5";
import axios from "axios"; // Make sure to install axios if not already installed
import Loader from "../Loader/Loader";
import useMinimumLoading from "../hooks/Useminimumloading";
import { API_URL } from "../../Config";

const Reviews = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
  // const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);
  const [isSidebarOpen, setIsSidebarOpen] = useState(() => {
    const savedState = localStorage.getItem("menubarOpen");

    if (savedState !== null) {
      return JSON.parse(savedState);
    }

    return window.innerWidth >= 1024;
  });

  const [feedbacks, setFeedbacks] = useState([]);
  const [loading, setLoading] = useState(true);
  const showLoader = useMinimumLoading(loading);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  // Statistics state
  const [statistics, setStatistics] = useState({
    totalFeedbacks: 0,
    pendingFeedbacks: 0,
    averageRating: 0,
  });

  // Fetch feedbacks and statistics
  useEffect(() => {
    fetchFeedbacks();
    fetchStatistics();
  }, []);

  const fetchFeedbacks = async () => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_URL}/feedbacks`); // Adjust the URL as needed
      setFeedbacks(response.data);
      setError(null);
    } catch (err) {
      console.error("Error fetching feedbacks:", err);
      setError("Failed to load feedbacks");
    } finally {
      setLoading(false);
    }
  };
  const fetchStatistics = async () => {
    try {
      const response = await axios.get(`${API_URL}/feedback-statistics`);
      if (response.data.success) {
        setStatistics(response.data.statistics);
      }
    } catch (err) {
      console.error("Error fetching statistics:", err);
    }
  };
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 1024;
      setIsMobile(mobile);

      if (mobile) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    setCurrentPage(1);
  }, [searchQuery]);
  const statusColors = {
    Excellent: "bg-green-100 text-green-500",
    Good: "bg-sky-100 text-sky-500",
    Average: "bg-yellow-100 text-yellow-400",
    Poor: "bg-red-100 text-red-500",
  };

  // Pagination
  const rowsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(1);

  const indexOfLastTable = currentPage * rowsPerPage;
  const indexOfFirstTable = indexOfLastTable - rowsPerPage;
  const filteredFeedbacks = searchQuery.trim()
    ? feedbacks.filter((f) => {
        const q = searchQuery.toLowerCase();
        return (
          f.bookingid?.toString().toLowerCase().includes(q) ||
          `${f.firstname} ${f.lastname}`
            .trim()
            .replace(/\s+/g, " ")
            .toLowerCase()
            .includes(q) ||
          f.email?.toLowerCase().includes(q) ||
          f.property?.toLowerCase().includes(q) ||
          f.ratetheoveralistay?.toLowerCase().includes(q)
        );
      })
    : feedbacks;

  const totalPages = Math.ceil(filteredFeedbacks.length / rowsPerPage);
  const currentFeedbacks = filteredFeedbacks.slice(
    indexOfFirstTable,
    indexOfLastTable,
  );
  // const currentFeedbacks = feedbacks.slice(indexOfFirstTable, indexOfLastTable);

  // const totalPages = Math.ceil(feedbacks.length / rowsPerPage);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const generatePageNumbers = () => {
    const pageNumbers = [];

    if (totalPages <= 3) {
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      if (currentPage > 2) {
        pageNumbers.push(1);
        pageNumbers.push("...");
      }
      for (let i = currentPage - 1; i <= currentPage + 1; i++) {
        if (i > 0 && i <= totalPages) {
          pageNumbers.push(i);
        }
      }
      if (currentPage < totalPages - 1) {
        pageNumbers.push("...");
        pageNumbers.push(totalPages);
      }
    }
    return pageNumbers;
  };

  const [selectedRows, setSelectedRows] = useState([]);

  const handleRowCheckboxChange = (id) => {
    setSelectedRows((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((selectedId) => selectedId !== id)
        : [...prevSelected, id],
    );
  };

  const handleSelectAll = () => {
    if (selectedRows.length === currentFeedbacks.length) {
      setSelectedRows([]);
    } else {
      setSelectedRows(currentFeedbacks.map((feedback) => feedback.id));
    }
  };

  const [isOpen_popupForm, setIsOpen_popupForm] = useState(false);
  // const [selectedFeedback, setSelectedFeedback] = useState(null);

  const handleViewFeedback = (bookingid) => {
    navigate(`/FeedbackForm/${bookingid}`, {
      state: { from: "reviews" },
    });
  };
  const handleDeleteFeedback = async (bookingid) => {
    if (window.confirm("Are you sure you want to delete this feedback?")) {
      try {
        await axios.delete(`${API_URL}/deleteFeedback/${bookingid}`);
        fetchFeedbacks(); // Refresh the list
      } catch (err) {
        console.error("Error deleting feedback:", err);
        alert("Failed to delete feedback");
      }
    }
  };

  // const fileInputRef = useRef(null);
  const [showPopup_filter, setShowPopup_filter] = useState(false);
  const filterRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowPopup_filter(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  //  if (showLoader) {
  //   return (
  //     <div className="flex">
  //       <Menubar
  //         isMobile={isMobile}
  //         isOpen={isSidebarOpen}
  //         setIsOpen={setIsSidebarOpen}
  //       />
  //     <div className="flex-1 p-12">
  //   <div className="flex justify-center items-start pt-55">
  //     <Loader label="Loading..." />
  //   </div>
  // </div>
  //     </div>
  //   );
  // }
  if (error) {
    return (
      <div className="flex">
        <Menubar
          isMobile={isMobile}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <div className="flex-1 p-6">
          <div className="flex justify-center items-center h-64">
            <div className="text-lg text-red-500">{error}</div>
          </div>
        </div>
      </div>
    );
  }

  // Function to get star display based on rating
  const getStarDisplay = (rating) => {
    if (rating >= 4.5) return "★★★★★";
    if (rating >= 3.5) return "★★★★☆";
    if (rating >= 2.5) return "★★★☆☆";
    if (rating >= 1.5) return "★★☆☆☆";
    if (rating >= 0.5) return "★☆☆☆☆";
    return "☆☆☆☆☆";
  };

  return (
    <div className="flex bg-[#F8F9FA]">
      <Menubar
        isOpen={isSidebarOpen}
        setIsOpen={setIsSidebarOpen}
        isMobile={isMobile}
      />

      <main
        className={`p-5 lg:p-6 transition-all duration-500 w-full ${
          isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
        }`}
      >
        <Outlet />

        {/* Header */}
        <div className="flex justify-between gap-5 items-start lg:items-center">
          <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
            <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
              Reviews & Feedback
            </p>
          </div>

          <div className="flex items-center gap-1">
            <div className="flex items-center">
              <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
                <div className="flex items-center justify-center fill-[#1D2826]">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    id="Isolation_Mode"
                    data-name="Isolation Mode"
                    viewBox="0 0 24 24"
                    width="18"
                    height="18"
                  >
                    <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Search..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
                />
              </div>

              <div className="">
                <button className="Btn">
                  <svg
                    className="svgIcon"
                    viewBox="0 0 384 512"
                    height="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
                  </svg>
                  <span className="icon2"></span>
                  <span className="tooltip text-sm">Download</span>
                </button>
              </div>

              <div className="flex items-center">
                <div className="relative inline-block" ref={filterRef}>
                  <div
                    onClick={() => setShowPopup_filter((prev) => !prev)}
                    className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${
                      showPopup_filter
                        ? "border-[#1D2826]"
                        : "border-transparent hover:border-[#1D2826]"
                    }`}
                  >
                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full -my-2.5">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "0%" : "100%",
                          transform: `translate(${
                            showPopup_filter ? "0" : "-100%"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>

                    <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
                      <div
                        className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
                        style={{
                          left: showPopup_filter ? "100%" : "0%",
                          transform: `translate(${
                            showPopup_filter ? "-100%" : "0"
                          }, -50%)`,
                        }}
                      ></div>
                    </div>
                  </div>

                  {showPopup_filter && (
                    <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4">
                      <div className="flex justify-between gap-2">
                        {["Today", "Week", "Month", "Year"].map((label) => (
                          <button
                            key={label}
                            className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-sm font-medium"
                          >
                            {label}
                          </button>
                        ))}
                      </div>

                      <div className="flex flex-col gap-2">
                        <div className="flex items-center gap-2">
                          <input
                            type="date"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                          <span className="text-sm text-gray-500">-</span>
                          <input
                            type="date"
                            className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Boxes */}
        {/* <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 items-center gap-5 text-gray-700 font-semibold mt-5">
          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Total Feedbacks</p>
              <p className="mt-2 text-lg text-black">
                {statistics.totalFeedbacks}
              </p>
            </div>

            <div>
              <VscFeedback className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>

          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Pending Feedbacks</p>
              <p className="mt-2 text-lg text-black">
                {statistics.pendingFeedbacks}
              </p>
            </div>

            <div>
              <VscFileSubmodule className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>

          <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
            <div>
              <p>Overall Rating</p>
              <div className="flex items-center gap-2">
                <p className="mt-2 text-lg text-black">
                  {statistics.averageRating}
                </p>
                <p className="text-sm text-gray-600">
                  {getStarDisplay(statistics.averageRating)}
                </p>
              </div>
            </div>

            <div>
              <IoStarHalf className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
            </div>
          </div>
        </div> */}

        {/* Button */}
        <div className="flex justify-between gap-10 mt-8">
          <div className="relative z-50">
            {isOpen_popupForm && (
              <div
                onClick={() => setIsOpen_popupForm(false)}
                className="fixed inset-0 bg-black bg-opacity-30 z-40 backdrop_popupForm"
              />
            )}
          </div>
        </div>

        {/* Table */}
        <div>
          <div className="shadow-md rounded-lg mt-5">
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left rtl:text-right text-gray-500">
                <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
                  <tr>
                    <th className="p-4">
                      <input
                        type="checkbox"
                        onChange={handleSelectAll}
                        checked={
                          selectedRows.length === currentFeedbacks.length &&
                          currentFeedbacks.length > 0
                        }
                      />
                    </th>
                    <th className="p-4">Booking ID</th>
                    <th className="p-4">Name</th>
                    <th className="p-4">Email</th>
                    <th className="p-4">Property</th>
                    <th className="p-4">Overall Stay Rating</th>
                    <th className="p-4">Booking Date</th>
                    <th className="p-4">Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {showLoader ? (
                    <tr>
                      <td colSpan={10}>
                        <Loader
                          label="Loading..."
                          fullScreen={false}
                          className="py-2"
                        />
                      </td>
                    </tr>
                  ) : currentFeedbacks.length === 0 ? (
                    <tr>
                      <td
                        colSpan={10}
                        className="text-center py-14 text-gray-400"
                      >
                        No feedbacks found.
                      </td>
                    </tr>
                  ) : (
                    currentFeedbacks.map((feedback) => {
                      return (
                        <tr
                          key={feedback.id}
                          className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
                        >
                          <td className="px-4 py-3">
                            <input
                              type="checkbox"
                              onChange={() =>
                                handleRowCheckboxChange(feedback.id)
                              }
                              checked={selectedRows.includes(feedback.id)}
                            />
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={`${feedback.bookingid} ${feedback.bookingid}`}
                              placement="left"
                            >
                              {feedback.bookingid}
                            </Tooltip>
                          </td>
                          <td className="px-4 py-3">
                            <Tooltip
                              title={`${feedback.firstname} ${feedback.lastname}`}
                              placement="left"
                            >
                              {feedback.firstname} {feedback.lastname}
                            </Tooltip>
                          </td>

                          <td className="px-4 py-3">
                            <Tooltip title={feedback.email} placement="left">
                              {feedback.email}
                            </Tooltip>
                          </td>

                          <td className="px-4 py-3">
                            <Tooltip title={feedback.property} placement="left">
                              {feedback.property}
                            </Tooltip>
                          </td>

                          <td className="px-4 py-3">
                            <div className="flex justify-between items-center">
                              <button
                                className={`w-24 px-1 py-1 rounded-lg text-xs scale-90 cursor-default ${
                                  statusColors[feedback.ratetheoveralistay] ||
                                  "bg-gray-500/20 text-gray-500"
                                } `}
                              >
                                {feedback.ratetheoveralistay || "N/A"}
                              </button>
                            </div>
                          </td>

                          <td className="px-4 py-3">
                            <Tooltip
                              title={new Date(
                                feedback.created_at,
                              ).toLocaleDateString()}
                              placement="left"
                            >
                              {new Date(
                                feedback.created_at,
                              ).toLocaleDateString()}
                            </Tooltip>
                          </td>

                          <td>
                            <div className="flex justify-center">
                              <button
                                className="pr-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                onClick={() =>
                                  handleViewFeedback(feedback.bookingid)
                                }
                                title="View Feedback"
                              >
                                <FaEye size={15} />
                              </button>

                              {/* <button
                              className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                              onClick={() => handleViewFeedback(feedback)}
                            >
                              <FaEdit size={14} />
                            </button>*/}

                              <button
                                className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
                                onClick={() =>
                                  handleDeleteFeedback(feedback.bookingid)
                                }
                              >
                                <MdDelete size={15} />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  )}
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            <nav
              className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
              aria-label="Table navigation"
            >
              <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
                Showing{" "}
                <span className="font-semibold text-gray-700">
                  {filteredFeedbacks.length > 0 ? indexOfFirstTable + 1 : 0}-
                  {Math.min(indexOfLastTable, filteredFeedbacks.length)}
                </span>{" "}
                of{" "}
                <span className="font-semibold text-gray-700">
                  {filteredFeedbacks.length}
                </span>
              </span>

              <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
                <li>
                  <button
                    onClick={handlePrevPage}
                    disabled={currentPage === 1}
                    className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700"
                  >
                    <MdKeyboardDoubleArrowLeft />
                  </button>
                </li>
                {generatePageNumbers().map((page, index) =>
                  page === "..." ? (
                    <li
                      key={index}
                      className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300"
                    >
                      <span>...</span>
                    </li>
                  ) : (
                    <li key={index}>
                      <button
                        onClick={() => handlePageChange(page)}
                        className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 ${
                          currentPage === page
                            ? "text-green-500 underline underline-offset-2"
                            : ""
                        }`}
                      >
                        {page}
                      </button>
                    </li>
                  ),
                )}
                <li>
                  <button
                    onClick={handleNextPage}
                    disabled={currentPage === totalPages}
                    className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700"
                  >
                    <MdKeyboardDoubleArrowRight />
                  </button>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Reviews;

// //old code
// import React, { useState, useEffect, useRef } from "react";
// import Menubar from "../Menubar/Menubar";
// import { Outlet } from "react-router-dom";
// import "../Dashboard/Dashboard.css";
// import { Tooltip } from "antd";
// import { MdKeyboardDoubleArrowLeft } from "react-icons/md";
// import { MdKeyboardDoubleArrowRight } from "react-icons/md";
// import { FaEdit, FaEye } from "react-icons/fa";
// import { MdCancel } from "react-icons/md";
// import { FiUploadCloud } from "react-icons/fi";
// import { MdDelete } from "react-icons/md";
// import { GiNetworkBars } from "react-icons/gi";
// import { BsFillLuggageFill } from "react-icons/bs";
// import { FaMoneyBillTrendUp } from "react-icons/fa6";
// import axios from "axios";

// const Reviews = () => {
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 1024);
//   const [isSidebarOpen, setIsSidebarOpen] = useState(window.innerWidth >= 1024);

//   useEffect(() => {
//     const handleResize = () => {
//       const mobile = window.innerWidth < 1024;
//       setIsMobile(mobile);

//       if (mobile) {
//         setIsSidebarOpen(false);
//       }
//     };

//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // const navigate = useNavigate();

//   const statusColors = {
//     CANCELLED: "bg-amber-800/20 text-amber-800",
//     CONFIRMED: "bg-green-500/20 text-green-500",
//     BOOKED: "bg-purple-500/20 text-purple-500",
//     FAILED: "bg-red-500/20 text-red-500",
//     PENDING: "bg-yellow-200/40 text-yellow-300",
//     PAID: "bg-transparent text-green-500",
//     UNPAID: "bg-transparent text-red-400",
//   };

//   const table_reviews = [
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1001",
//       date: "05-02-2025",
//       productName: "Wxyz",
//       payment: "149.99",
//       method: "Pre-Paid",
//       customer: "John Doe",
//       awb: "AWB-5001",
//       status: "PENDING",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1002",
//       date: "04-02-2025",
//       productName: "Abcd",
//       payment: "179.99",
//       method: "COD",
//       customer: "Jane Smith",
//       awb: "AWB-5002",
//       status: "BOOKED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1003",
//       date: "03-02-2025",
//       productName: "Efgh",
//       payment: "129.99",
//       method: "Pre-Paid",
//       customer: "Alice Brown",
//       awb: "AWB-5003",
//       status: "CANCELLED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1004",
//       date: "02-02-2025",
//       productName: "Ijkl",
//       payment: "1109.99",
//       method: "COD",
//       customer: "Bob Johnson",
//       awb: "AWB-5004",
//       status: "FAILED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1005",
//       date: "01-02-2025",
//       productName: "Mnop",
//       payment: "159.99",
//       method: "Pre-Paid",
//       customer: "Charlie Wilson",
//       awb: "AWB-5005",
//       status: "CONFIRMED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1001",
//       date: "05-02-2025",
//       productName: "Wxyz",
//       payment: "149.99",
//       method: "COD",
//       customer: "John Doe",
//       awb: "AWB-5001",
//       status: "PENDING",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1002",
//       date: "04-02-2025",
//       productName: "Abcd",
//       payment: "179.99",
//       method: "Pre-Paid",
//       customer: "Jane Smith",
//       awb: "AWB-5002",
//       status: "BOOKED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1003",
//       date: "03-02-2025",
//       productName: "Efgh",
//       payment: "129.99",
//       method: "COD",
//       customer: "Alice Brown",
//       awb: "AWB-5003",
//       status: "CANCELLED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1004",
//       date: "02-02-2025",
//       productName: "Ijkl",
//       payment: "1109.99",
//       method: "Pre-Paid",
//       customer: "Bob Johnson",
//       awb: "AWB-5004",
//       status: "FAILED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1005",
//       date: "01-02-2025",
//       productName: "Mnop",
//       payment: "159.99",
//       method: "COD",
//       customer: "Charlie Wilson",
//       awb: "AWB-5005",
//       status: "CONFIRMED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1001",
//       date: "05-02-2025",
//       productName: "Wxyz",
//       payment: "149.99",
//       method: "Pre-Paid",
//       customer: "John Doe",
//       awb: "AWB-5001",
//       status: "PENDING",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1002",
//       date: "04-02-2025",
//       productName: "Abcd",
//       payment: "179.99",
//       method: "COD",
//       customer: "Jane Smith",
//       awb: "AWB-5002",
//       status: "BOOKED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1003",
//       date: "03-02-2025",
//       productName: "Efgh",
//       payment: "129.99",
//       method: "Pre-Paid",
//       customer: "Alice Brown",
//       awb: "AWB-5003",
//       status: "CANCELLED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1004",
//       date: "02-02-2025",
//       productName: "Ijkl",
//       payment: "1109.99",
//       method: "COD",
//       customer: "Bob Johnson",
//       awb: "AWB-5004",
//       status: "FAILED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1005",
//       date: "01-02-2025",
//       productName: "Mnop",
//       payment: "159.99",
//       method: "Pre-Paid",
//       customer: "Charlie Wilson",
//       awb: "AWB-5005",
//       status: "CONFIRMED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1001",
//       date: "05-02-2025",
//       productName: "Wxyz",
//       payment: "149.99",
//       method: "COD",
//       customer: "John Doe",
//       awb: "AWB-5001",
//       status: "PENDING",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1002",
//       date: "04-02-2025",
//       productName: "Abcd",
//       payment: "179.99",
//       method: "Pre-Paid",
//       customer: "Jane Smith",
//       awb: "AWB-5002",
//       status: "BOOKED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1003",
//       date: "03-02-2025",
//       productName: "Efgh",
//       payment: "129.99",
//       method: "COD",
//       customer: "Alice Brown",
//       awb: "AWB-5003",
//       status: "CANCELLED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1004",
//       date: "02-02-2025",
//       productName: "Ijkl",
//       payment: "1109.99",
//       method: "Pre-Paid",
//       customer: "Bob Johnson",
//       awb: "AWB-5004",
//       status: "FAILED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1005",
//       date: "01-02-2025",
//       productName: "Mnop",
//       payment: "159.99",
//       method: "COD",
//       customer: "Charlie Wilson",
//       awb: "AWB-5005",
//       status: "CONFIRMED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1001",
//       date: "05-02-2025",
//       productName: "Wxyz",
//       payment: "149.99",
//       method: "Pre-Paid",
//       customer: "John Doe",
//       awb: "AWB-5001",
//       status: "PENDING",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1002",
//       date: "04-02-2025",
//       productName: "Abcd",
//       payment: "179.99",
//       method: "COD",
//       customer: "Jane Smith",
//       awb: "AWB-5002",
//       status: "BOOKED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1003",
//       date: "03-02-2025",
//       productName: "Efgh",
//       payment: "129.99",
//       method: "Pre-Paid",
//       customer: "Alice Brown",
//       awb: "AWB-5003",
//       status: "CANCELLED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1004",
//       date: "02-02-2025",
//       productName: "Ijkl",
//       payment: "1109.99",
//       method: "COD",
//       customer: "Bob Johnson",
//       awb: "AWB-5004",
//       status: "FAILED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1005",
//       date: "01-02-2025",
//       productName: "Mnop",
//       payment: "159.99",
//       method: "Pre-Paid",
//       customer: "Charlie Wilson",
//       awb: "AWB-5005",
//       status: "CONFIRMED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1001",
//       date: "05-02-2025",
//       productName: "Wxyz",
//       payment: "149.99",
//       method: "COD",
//       customer: "John Doe",
//       awb: "AWB-5001",
//       status: "PENDING",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1002",
//       date: "04-02-2025",
//       productName: "Abcd",
//       payment: "179.99",
//       method: "Pre-Paid",
//       customer: "Jane Smith",
//       awb: "AWB-5002",
//       status: "BOOKED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1003",
//       date: "03-02-2025",
//       productName: "Efgh",
//       payment: "129.99",
//       method: "COD",
//       customer: "Alice Brown",
//       awb: "AWB-5003",
//       status: "CANCELLED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1004",
//       date: "02-02-2025",
//       productName: "Ijkl",
//       payment: "1109.99",
//       method: "Pre-Paid",
//       customer: "Bob Johnson",
//       awb: "AWB-5004",
//       status: "FAILED",
//     },
//     {
//       channel: "Alice Wilson",
//       order: "ORD-1005",
//       date: "01-02-2025",
//       productName: "Mnop",
//       payment: "159.99",
//       method: "COD",
//       customer: "Charlie Wilson",
//       awb: "AWB-5005",
//       status: "CONFIRMED",
//     },
//   ];

//   const rowsPerPage_reviews = 20;
//   const [currentPage_reviews, setCurrentPage_reviews] = useState(1);

//   const indexOfLastTable_reviews = currentPage_reviews * rowsPerPage_reviews;
//   const indexOfFirstTable_reviews =
//     indexOfLastTable_reviews - rowsPerPage_reviews;

//   const current_reviews = table_reviews.slice(
//     indexOfFirstTable_reviews,
//     indexOfLastTable_reviews,
//   );

//   const totalPages_reviews = Math.ceil(
//     table_reviews.length / rowsPerPage_reviews,
//   );

//   const handlePageChange_reviews = (pageNumber_reviews) => {
//     setCurrentPage_reviews(pageNumber_reviews);
//   };

//   const handleNextPage_reviews = () => {
//     if (currentPage_reviews < totalPages_reviews) {
//       setCurrentPage_reviews(currentPage_reviews + 1);
//     }
//   };

//   const handlePrevPage_reviews = () => {
//     if (currentPage_reviews > 1) {
//       setCurrentPage_reviews(currentPage_reviews - 1);
//     }
//   };

//   const generatePageNumbers_reviews = () => {
//     const pageNumbers_reviews = [];

//     if (totalPages_reviews <= 3) {
//       for (let i = 1; i <= totalPages_reviews; i++) {
//         pageNumbers_reviews.push(i);
//       }
//     } else {
//       if (currentPage_reviews > 2) {
//         pageNumbers_reviews.push(1);
//         pageNumbers_reviews.push("...");
//       }
//       for (let i = currentPage_reviews - 1; i <= currentPage_reviews + 1; i++) {
//         if (i > 0 && i <= totalPages_reviews) {
//           pageNumbers_reviews.push(i);
//         }
//       }
//       if (currentPage_reviews < totalPages_reviews - 1) {
//         pageNumbers_reviews.push("...");
//         pageNumbers_reviews.push(totalPages_reviews);
//       }
//     }
//     return pageNumbers_reviews;
//   };

//   const [selectedRows_reviews, setSelectedRows_reviews] = useState([]);

//   const handleRowCheckboxChange_reviews = (order) => {
//     setSelectedRows_reviews((prevSelected) =>
//       prevSelected.includes(order)
//         ? prevSelected.filter((id) => id !== order)
//         : [...prevSelected, order],
//     );
//   };

//   const handleSelectAll_reviews = () => {
//     if (selectedRows_reviews.length === current_reviews.length) {
//       setSelectedRows_reviews([]);
//     } else {
//       setSelectedRows_reviews(current_reviews.map((booking) => booking.order));
//     }
//   };

//   const [isOpen_popupForm, setIsOpen_popupForm] = useState(false);

//   const fileInputRef = useRef(null);

//   const handleBoxClick = () => {
//     fileInputRef.current.click();
//   };

//   const [showPopup_filter, setShowPopup_filter] = useState(false);
//   const filterRef = useRef(null);

//   useEffect(() => {
//     function handleClickOutside(event) {
//       if (filterRef.current && !filterRef.current.contains(event.target)) {
//         setShowPopup_filter(false);
//       }
//     }

//     document.addEventListener("mousedown", handleClickOutside);
//     return () => document.removeEventListener("mousedown", handleClickOutside);
//   }, []);

//   return (
//     <div className="flex bg-[#F8F9FA]">
//       <Menubar
//         isOpen={isSidebarOpen}
//         setIsOpen={setIsSidebarOpen}
//         isMobile={isMobile}
//       />

//       <main
//         className={`p-5 lg:p-6 transition-all duration-500 w-full ${
//           isMobile ? "ml-0" : isSidebarOpen ? "ml-64" : "ml-16"
//         }`}
//       >
//         <Outlet />

//         {/* Header */}
//         <div className="flex justify-between gap-5 items-start lg:items-center">
//           <div className="flex flex-col lg:flex-row gap-5 items-start lg:items-center">
//             <p className="font-semibold text-xl text-gray-700 ml-10 lg:ml-0">
//               Reviews & Feedback
//             </p>
//           </div>

//           <div className="flex items-center gap-1">
//             <div className="flex items-center">
//               <div className="mr-2 p-2 overflow-hidden w-8 h-8 hover:w-[120px] sm:hover:w-[250px] hover:border hover:border-[#1D2826] hover:shadow-[2px_2px_20px_rgba(0,0,0,0.08)] rounded-full flex group items-center hover:duration-300 duration-300">
//                 <div className="flex items-center justify-center fill-[#1D2826]">
//                   <svg
//                     xmlns="http://www.w3.org/2000/svg"
//                     id="Isolation_Mode"
//                     data-name="Isolation Mode"
//                     viewBox="0 0 24 24"
//                     width="18"
//                     height="18"
//                   >
//                     <path d="M18.9,16.776A10.539,10.539,0,1,0,16.776,18.9l5.1,5.1L24,21.88ZM10.5,18A7.5,7.5,0,1,1,18,10.5,7.507,7.507,0,0,1,10.5,18Z"></path>
//                   </svg>
//                 </div>
//                 <input
//                   type="text"
//                   className="border-none outline-none text-sm bg-transparent w-full font-normal px-2 focus:ring-0"
//                 />
//               </div>

//               <div className="">
//                 <button className="Btn">
//                   <svg
//                     className="svgIcon"
//                     viewBox="0 0 384 512"
//                     height="1em"
//                     xmlns="http://www.w3.org/2000/svg"
//                   >
//                     <path d="M169.4 470.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 370.8 224 64c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 306.7L54.6 265.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z"></path>
//                   </svg>
//                   <span className="icon2"></span>
//                   <span className="tooltip text-sm">Download</span>
//                 </button>
//               </div>

//               <div className="flex items-center">
//                 <div className="relative inline-block" ref={filterRef}>
//                   <div
//                     onClick={() => setShowPopup_filter((prev) => !prev)}
//                     className={`flex flex-col items-center gap-4 cursor-pointer select-none group scale-[0.75] py-2.5 px-2 rounded-full border-2 transition-all duration-300 ${
//                       showPopup_filter
//                         ? "border-[#1D2826]"
//                         : "border-transparent hover:border-[#1D2826]"
//                     }`}
//                   >
//                     <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? "100%" : "0%",
//                           transform: `translate(${
//                             showPopup_filter ? "-100%" : "0"
//                           }, -50%)`,
//                         }}
//                       ></div>
//                     </div>

//                     <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full -my-2.5">
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? "0%" : "100%",
//                           transform: `translate(${
//                             showPopup_filter ? "0" : "-100%"
//                           }, -50%)`,
//                         }}
//                       ></div>
//                     </div>

//                     <div className="relative w-6 h-0.5 bg-[#1D2826] rounded-full">
//                       <div
//                         className="absolute top-1/2 -translate-y-1/2 w-2 h-2 rounded-full border-2 border-black bg-white transition-all duration-300"
//                         style={{
//                           left: showPopup_filter ? "100%" : "0%",
//                           transform: `translate(${
//                             showPopup_filter ? "-100%" : "0"
//                           }, -50%)`,
//                         }}
//                       ></div>
//                     </div>
//                   </div>

//                   {showPopup_filter && (
//                     <div className="absolute top-full mt-1 right-0 bg-white border rounded-lg shadow-custom z-10 p-4 space-y-4">
//                       <div className="flex justify-between gap-2">
//                         {["Today", "Week", "Month", "Year"].map((label) => (
//                           <button
//                             key={label}
//                             className="flex-1 py-1 px-2 bg-gray-100 active:bg-[#DAE0CE] hover:bg-[#DAE0CE] rounded text-sm font-medium"
//                           >
//                             {label}
//                           </button>
//                         ))}
//                       </div>

//                       <div className="flex flex-col gap-2">
//                         <div className="flex items-center gap-2">
//                           <input
//                             type="date"
//                             className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                           />
//                           <span className="text-sm text-gray-500">-</span>
//                           <input
//                             type="date"
//                             className="border text-sm rounded px-2 py-1 w-full focus:outline-none focus:ring-1 focus:ring-green-600 focus:border-black"
//                           />
//                         </div>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Boxes */}
//         <div className="grid grid-cols-1 sm:grid-cols-3 lg:grid-cols-3 items-center gap-5 text-gray-700 font-semibold mt-5">
//           <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//             <div>
//               <p>Total Feedbacks</p>
//               <p className="mt-2 text-lg text-black">
//                 53,000 <sup className="text-green-500">+55%</sup>
//               </p>
//             </div>

//             <div>
//               <GiNetworkBars className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//           </div>

//           <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//             <div>
//               <p>Average Star Rating</p>
//               <p className="mt-2 text-lg text-black">
//                 23 <sup className="text-green-500">+5%</sup>
//               </p>
//             </div>

//             <div>
//               <BsFillLuggageFill className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//           </div>

//           <div className="flex items-center justify-between gap-5 bg-[#DAE0CE] py-2 px-4 rounded-lg">
//             <div>
//               <p>Scope for Improvement</p>
//               <p className="mt-2 text-lg text-black">
//                 $173,000 <sup className="text-green-500">+8%</sup>
//               </p>
//             </div>

//             <div>
//               <FaMoneyBillTrendUp className="bg-[#3C4C4E] text-3xl text-white p-1.5 rounded-md" />
//             </div>
//           </div>
//         </div>

//         {/* Button */}
//         <div className="flex justify-between gap-10 mt-8">
//           {/*    <button
//             onClick={() => setIsOpen_popupForm(true)}
//             className="px-6 z-30 py-2 bg-[#1D2826] rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-900 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//           >
//             + Add Review
//           </button> */}

//           <div className="relative z-50">
//             {isOpen_popupForm && (
//               <div
//                 onClick={() => setIsOpen_popupForm(false)}
//                 className="fixed inset-0 bg-black bg-opacity-30 z-40 backdrop_popupForm"
//               />
//             )}

//             {/* <div
//               className={`fixed top-0 right-0 h-full w-[85%] md:w-[640px] bg-white z-50 shadow-lg transform transition-transform duration-500 ease-in-out ${
//                 isOpen_popupForm ? "translate-x-0" : "translate-x-full"
//               } panel_popupForm`}
//             >
//               <div className="p-4 flex justify-between items-center border-b header_popupForm">
//                 <h2 className="text-[#1D2826] text-lg font-semibold">
//                   Add Review
//                 </h2>
//                 <button
//                   onClick={() => setIsOpen_popupForm(false)}
//                   className="text-gray-500 hover:text-black text-xl"
//                 >
//                   <MdCancel />
//                 </button>
//               </div>

//               <div className="p-4">
//                 <div className="font-semibold text-gray-500 text-sm text-right">
//                   Review ID: <span className="text-black my-1">10294837</span>
//                 </div>

//                 <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-3 items-center max-h-[85vh] overflow-y-auto py-2">
//                   <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       First Name
//                     </label>
//                     <input
//                       placeholder="Enter first name"
//                       name="input"
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Last Name
//                     </label>
//                     <input
//                       placeholder="Enter last name"
//                       name="input"
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Email
//                     </label>
//                     <input
//                       placeholder="Enter your email"
//                       name="input"
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label
//                       for="input"
//                       className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit"
//                     >
//                       Phone Number
//                     </label>
//                     <input
//                       placeholder="Enter phone number"
//                       name="input"
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md"
//                     />
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Country
//                     </label>

//                     <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
//                       <option value="">Select your country</option>
//                       <option value="">India</option>
//                       <option value="">Japan</option>
//                       <option value="">Singapore</option>
//                     </select>
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       City
//                     </label>

//                     <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
//                       <option value="">Select your city</option>
//                       <option value="">Rajkot</option>
//                       <option value="">Ahmedabad</option>
//                       <option value="">Junagadh</option>
//                     </select>
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Package | destination
//                     </label>

//                     <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
//                       <option value="">
//                         Select your package | destination
//                       </option>
//                       <option value="">Option1</option>
//                       <option value="">Option2</option>
//                       <option value="">Option3</option>
//                     </select>
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Booking Date & Time
//                     </label>
//                     <input
//                       type="text"
//                       readOnly
//                       value={new Date().toLocaleString()}
//                       className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md text-black"
//                     />
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       OTA
//                     </label>

//                     <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
//                       <option value="">Select OTA</option>
//                       <option value="">Option1</option>
//                       <option value="">Option2</option>
//                       <option value="">Option3</option>
//                     </select>
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Booking Status
//                     </label>

//                     <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
//                       <option value="">Select booking status</option>
//                       <option value="">Option1</option>
//                       <option value="">Option2</option>
//                       <option value="">Option3</option>
//                     </select>
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Payment Status
//                     </label>

//                     <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
//                       <option value="">Select payment status</option>
//                       <option value="">Option1</option>
//                       <option value="">Option2</option>
//                       <option value="">Option3</option>
//                     </select>
//                   </div>

//                   <div className="flex flex-col w-full">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       Property
//                     </label>

//                     <select className="border-gray-400 p-3 text-sm border rounded-lg w-full focus:outline-none placeholder:text-black/25 focus:ring-0 focus:border-black focus:shadow-md">
//                       <option value="">Select a property</option>
//                       <option value="Villa Serenity">Villa Serenity</option>
//                       <option value="Villa Arcadia">Villa Arcadia</option>
//                       <option value="Villa Mandovi">Villa Mandovi</option>
//                       <option value="Villa Sal">Villa Sal</option>
//                     </select>
//                   </div>

//                   <div className="flex flex-col w-full sm:col-span-2">
//                     <label className="text-gray-400 text-xs font-semibold relative top-2 ml-2 px-1 bg-white w-fit">
//                       ID Proof
//                     </label>

//                     <div
//                       onClick={handleBoxClick}
//                       className="border-2 border-dashed border-gray-400 rounded-lg flex flex-col items-center justify-center text-center p-6 cursor-pointer hover:border-black transition-all"
//                     >
//                       <FiUploadCloud className="w-10 h-10 text-green-600 mb-2" />

//                       <p className="text-sm font-medium text-black">
//                         Select File to Upload
//                       </p>
//                       <p className="text-xs text-gray-400">Image or PDF</p>

//                       <input
//                         ref={fileInputRef}
//                         type="file"
//                         accept="image/*,.pdf"
//                         className="hidden"
//                       />
//                     </div>
//                   </div>

//                   <div className="grid grid-cols-2 gap-3">
//                     <button
//                       onClick={() => setIsOpen_popupForm(false)}
//                       className="px-6 z-30 py-2 bg-gray-800 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-gray-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm"
//                     >
//                       Cancel
//                     </button>

//                     <button className="px-6 z-30 py-2 bg-green-900 rounded-lg text-center text-white relative hover:scale-95 after:-z-20 after:absolute after:h-1 after:w-1 after:bg-green-700 after:left-5 overflow-hidden after:bottom-0 after:translate-y-full after:rounded-md after:hover:scale-[300] after:hover:transition-all after:hover:duration-700 after:transition-all after:duration-700 transition-all duration-700 text-sm">
//                       Save
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div> */}
//           </div>
//         </div>

//         {/* Table */}
//         <div>
//           <div className="shadow-md rounded-lg mt-5">
//             <div className="overflow-x-auto">
//               <table className="w-full text-sm text-left rtl:text-right text-gray-500">
//                 <thead className="text-xs text-gray-400 uppercase bg-green-50 border-b">
//                   <tr>
//                     <th className="p-4">
//                       <input
//                         type="checkbox"
//                         onChange={handleSelectAll_reviews}
//                         checked={
//                           selectedRows_reviews.length ===
//                             current_reviews.length && current_reviews.length > 0
//                         }
//                       />
//                     </th>
//                     <th className="p-4 w-1/10">Name</th>
//                     <th className="p-4 w-1/10">Review</th>
//                     <th className="p-4 w-1/10">Booking Date</th>
//                     <th className="p-4 w-1/12">Status</th>
//                     <th className="p-4 w-1/10">Payment</th>
//                     <th className="p-4 w-1/10">Actions</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {current_reviews.map((table_reviews, index) => {
//                     return (
//                       <tr
//                         key={index}
//                         className="bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 text-gray-800"
//                       >
//                         <td className="px-4 py-3">
//                           <input
//                             type="checkbox"
//                             onChange={() =>
//                               handleRowCheckboxChange_reviews(
//                                 table_reviews.order,
//                               )
//                             }
//                             checked={selectedRows_reviews.includes(
//                               table_reviews.order,
//                             )}
//                           />
//                         </td>

//                         <td
//                           className="px-4 py-3"
//                           data-full-content={table_reviews.customer}
//                         >
//                           <Tooltip
//                             title={table_reviews.customer}
//                             placement="left"
//                           >
//                             {table_reviews.customer}
//                           </Tooltip>
//                         </td>
//                         <td className="px-4 py-3">
//                           <Tooltip
//                             title={table_reviews.productName}
//                             placement="left"
//                           >
//                             {table_reviews.productName}
//                           </Tooltip>
//                         </td>
//                         <td className="px-4 py-3">
//                           <Tooltip title={table_reviews.date} placement="left">
//                             {table_reviews.date}
//                           </Tooltip>
//                         </td>

//                         <td className="px-4 py-3">
//                           <div className="flex justify-between items-center">
//                             <button
//                               className={`w-20 px-1 py-1 rounded-lg text-xs scale-90 cursor-default ${
//                                 statusColors[table_reviews.status]
//                               } `}
//                             >
//                               {table_reviews.status}
//                             </button>
//                           </div>
//                         </td>

//                         <td className="px-4 py-3">
//                           <Tooltip
//                             title={table_reviews.payment}
//                             placement="left"
//                           >
//                             {table_reviews.payment}
//                           </Tooltip>
//                         </td>

//                         <td>
//                           <div className="flex">
//                             <button
//                               className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
//                               // onClick={() => navigate("/")}
//                               onClick={() => setIsOpen_popupForm(true)}
//                             >
//                               <FaEye size={15} />
//                             </button>

//                             <button
//                               className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
//                               // onClick={() => navigate("/")}
//                               onClick={() => setIsOpen_popupForm(true)}
//                             >
//                               <FaEdit size={14} />
//                             </button>

//                             <button
//                               className="px-2 py-1 text-gray-400 hover:text-black hover:dark:text-white hover:scale-125 transition-all duration-300"
//                               // onClick={() => navigate("/")}
//                             >
//                               <MdDelete size={15} />
//                             </button>
//                           </div>
//                         </td>
//                       </tr>
//                     );
//                   })}
//                 </tbody>
//               </table>
//             </div>

//             <nav
//               className="flex items-center flex-column flex-wrap md:flex-row justify-between rounded-b-lg px-2 py-1 bg-[#f7f7f7]"
//               aria-label="Table navigation"
//             >
//               <span className="text-xs font-normal text-gray-500 mb-4 md:mb-0 block w-full md:inline md:w-auto">
//                 Showing{" "}
//                 <span className="font-semibold text-gray-700 dark:text-white">
//                   {indexOfFirstTable_reviews + 1}-
//                   {Math.min(indexOfLastTable_reviews, table_reviews.length)}
//                 </span>{" "}
//                 of{" "}
//                 <span className="font-semibold text-gray-700 dark:text-white">
//                   {table_reviews.length}
//                 </span>
//               </span>

//               <ul className="inline-flex -space-x-px rtl:space-x-reverse text-xs h-8">
//                 <li>
//                   <button
//                     onClick={handlePrevPage_reviews}
//                     disabled={currentPage_reviews === 1}
//                     className="flex items-center justify-center px-1 h-8 ms-0 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-s-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
//                   >
//                     <MdKeyboardDoubleArrowLeft />
//                   </button>
//                 </li>
//                 {generatePageNumbers_reviews().map((page, index) =>
//                   page === "..." ? (
//                     <li
//                       key={index}
//                       className="px-1 h-8 flex items-center justify-center text-gray-500 bg-[#f7f7f7] border-gray-300 dark:text-gray-400 dark:bg-gray-800 dark:border-gray-700"
//                     >
//                       <span>...</span>
//                     </li>
//                   ) : (
//                     <li key={index}>
//                       <button
//                         onClick={() => handlePageChange_reviews(page)}
//                         className={`flex items-center justify-center px-3 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white ${
//                           currentPage_reviews === page
//                             ? "text-green-500 underline underline-offset-2"
//                             : ""
//                         }`}
//                       >
//                         {page}
//                       </button>
//                     </li>
//                   ),
//                 )}
//                 <li>
//                   <button
//                     onClick={handleNextPage_reviews}
//                     disabled={currentPage_reviews === totalPages_reviews}
//                     className="flex items-center justify-center px-1 h-8 leading-tight text-gray-500 bg-[#f7f7f7] border-gray-300 rounded-e-lg hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white"
//                   >
//                     <MdKeyboardDoubleArrowRight />
//                   </button>
//                 </li>
//               </ul>
//             </nav>
//           </div>
//         </div>
//       </main>
//     </div>
//   );
// };

// export default Reviews;
